<script>
	import { Slidy } from 'svelte-slidy';
  import cards from '../cards.js';
	let name = 'Slidy'
	
	const slidy_cards = {
		slides: cards,
		wrap: {
			id: 'slidy_cards',
			width: '100vw',
			height: '100vh',
			padding: '50px 0 50px',
			align: 'middle',
			alignmargin: 0,
		},
		slide: {
			gap: 50,
			width: '80vw',
			height: '100vh',
			backimg: false,
			imgsrckey: 'src',
			objectfit: 'contain',
		},
		controls: {
			dots: true,
			dotsnum: true,
			dotsarrow: true,
			dotspure: true,
			arrows: false,
			keys: true,
			drag: true,
			wheel: true,
		},
		options: {
			axis: 'x',
			loop: true,
			duration: 350,
		}
	}
</script>

<h1>Hello <span>{name}</span> cards!</h1>

<Slidy {...slidy_cards} let:item >
	<div class="slide">
		<img alt="{item.header}" src="{item.src}"/>
		<article>
			<h2>{item.header}</h2>
			<p>
				{item.text}
			</p>
		</article>
	</div>
</Slidy>

<style>
	@media screen and (min-width: 500px) {
		:global(#slidy_cards .slidy-ul li) {width: 60vw;}
	}	
	:global(#slidy_cards .slidy-ul li img) {
			transform: scale(1);
			transition: transform 350ms, box-shadow 350ms;
	}
	:global(#slidy_cards .slidy-ul li) {overflow: hidden}
	:global(#slidy_cards .slidy-ul li.active img) {
			transform: scale(0.9);
			box-shadow: 0 10px 10px rgba(0, 0, 0, 0.36);
	}
	:global(body) { margin: 0; padding: 0}
	.slide {
		position: relative;
		display: flex;
		flex-flow: row;
		text-align: center;
		align-content: center;
		justify-content: center;
		height: 100%;
		border-radius: 1rem;
	}
	.slide img {
		max-height: 200px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		vertical-align: middle;
		object-fit: cover;
		position: relative;
		z-index: 1;
		border-radius: 1rem;
		box-shadow: 0 14px 25px rgba(0, 0, 0, 0.16);
	}
	.slide article {
		padding: 1rem;
	}
	h1 {text-align: center;}
	h1 span {color: red}
</style>
